import React from 'react';
import {
  ListItem,
  List,
  ListItemSecondaryAction,
  ListItemText,
  Container,
  IconButton,
  Typography,
  ListSubheader,
  Tooltip,
  Fab,
  makeStyles,
  useTheme,
} from '@material-ui/core';
import PhonelinkSetupIcon from '@material-ui/icons/PhonelinkSetup';
import DeleteIcon from '@material-ui/icons/Delete';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { Skeleton } from '@material-ui/lab';
import clsx from 'clsx';
import { updateUi } from '../../redux/actions/uiActions';
import { actions } from '../../redux/actions/actionsHandler';
import { useSelector, useDispatch } from 'react-redux';
import { isLoaded } from 'react-redux-firebase';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  container: { ...theme.container(2), marginLeft: 0 },
  listContainer: {
    minWidth: theme.spacing(30),
    maxWidth: theme.spacing(50),
    marginBottom: theme.spacing(2),
  },
  listItem: {
    paddingRight: theme.spacing(15),
    width: 'auto',
  },
  itemText: {
    margin: theme.spacing(1, 1),
  },
  avatar: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    padding: theme.spacing(0.5),
  },
  iconContainer: {
    display: 'flex',
    alignContent: 'center',
  },
  skeletonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignContent: 'flex-start',
  },
  skeletonItemText: {
    minWidth: theme.spacing(30),
    margin: theme.spacing(0, 1),
    height: theme.spacing(8),
  },
}));

export default function ManageDomains(props) {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { authDomains } = useSelector((s) => s.firebase.profile);
  const intl = useIntl();

  const showRemoveDomainDialogConfirmation = (domain) => {
    dispatch(
      updateUi({
        dialog: {
          title: intl.formatMessage({ id: 'manDom.remConfTitle' }),
          message: intl.formatMessage(
            { id: 'manDom.remConfMsg' },
            { nl: <br key={`mdnl${domain}`} />, domain: <b key={`mdb0${domain}`}>{domain}</b> }
          ),
          confirmAction: actions.REMOVE_DOMAIN,
          actionData: { domain, currentDomains: authDomains ? authDomains : [] },
          useCheckbox: true,
          checkboxState: false,
          checkboxMessage: <b>{intl.formatMessage({ id: 'manDom.remConfCheckboxMsg' })}</b>,
          show: true,
        },
      })
    );
  };

  return (
    <Container className={classes.container}>
      <Typography variant="h4" style={theme.text.title}>
        {intl.formatMessage({ id: 'manDom.title' })}
      </Typography>
      <Typography variant="subtitle1" style={theme.text.subtitle}>
        {intl.formatMessage({ id: 'manDom.subtitle' })}
      </Typography>
      <List
        className={classes.listContainer}
        subheader={<ListSubheader>{intl.formatMessage({ id: 'manDom.domains' })}</ListSubheader>}
      >
        {isLoaded(authDomains)
          ? [...authDomains].sort().map((domain, index) => {
              return (
                <ListItem key={`${domain}${index}`} button alignItems="flex-start" className={classes.listItem}>
                  <ListItemText id={domain} className={classes.itemText} primary={domain} />
                  <ListItemSecondaryAction>
                    <Tooltip title={intl.formatMessage({ id: 'manDom.editSett' })}>
                      <IconButton
                        component={Link}
                        to={`/domain/${domain}/settings`}
                        edge="start"
                        aria-label={intl.formatMessage({ id: 'edit' })}
                        style={{ color: theme.palette.info.main }}
                      >
                        <PhonelinkSetupIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={intl.formatMessage({ id: 'remove' })}>
                      <IconButton
                        edge="end"
                        aria-label={intl.formatMessage({ id: 'remove' })}
                        style={{ color: theme.palette.error.main }}
                        onClick={() => showRemoveDomainDialogConfirmation(domain)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </ListItemSecondaryAction>
                </ListItem>
              );
            })
          : [0, 1, 2].map((v) => (
              <Container className={clsx(classes.listItem, classes.skeletonContainer)} key={`skel${v}`}>
                <Skeleton variant="text" animation="wave" className={classes.skeletonItemText} />
              </Container>
            ))}

        <ListItem />
        <ListItem>
          <Fab variant="extended" size="medium" color="secondary" aria-label="add" component={Link} to="/addDomain">
            <AddCircleIcon style={{ marginRight: theme.spacing(1) }} />
            {intl.formatMessage({ id: 'manDom.addDomain' })}
          </Fab>
        </ListItem>
      </List>
    </Container>
  );
}
